import { render, staticRenderFns } from "./CatalogScreen.vue?vue&type=template&id=447d9978"
import script from "./CatalogScreen.vue?vue&type=script&lang=js"
export * from "./CatalogScreen.vue?vue&type=script&lang=js"
import style0 from "./CatalogScreen.vue?vue&type=style&index=0&id=447d9978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports